module.exports = __webpack_public_path__ + "static/go-burguer-bg-burguer-do-mes-c0f63f5f158cf2375fb4d00d384d988b.jpg";